import ExploreHeader from '@/assets/about-us/ExploreHeader'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import ExplorePassionMain from '@/assets/about-us/explore_passion_main.webp'
import CubeImage from '@/assets/about-us/cube.png'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import Link from 'next/link'
import { ReactGAEvent } from '@/components/ReactGAs'

const ExplorePassion = () => {
	const router = useRouter()

	const clickGAHandler = (event) => {
		ReactGAEvent({ action: 'Explore open position', event: 'Click', label: 'Button', category: 'Careers' })
	}

	return (
		<div className='explore-passion-container'>
			<ExploreHeader />
			<div className='explore-passion-wapper'>
				<Container fluid='lg'>
					<Row className='explore-passion-content'>
						<Col xs={12} md={12} lg={6}>
							<Image src={ExplorePassionMain} alt='..' />
						</Col>
						<Col xs={12} md={12} lg={6}>
							<div className='explore-passion-text-content'>
								<div>
									<h3>Explore your passion. Create lasting change.</h3>
									<p>Work with us—and transform your career while transforming lives.</p>
								</div>
								<Link href={'/careers'} onClick={clickGAHandler}>
									<button className='explore-open-position border-0'>
										<p>Explore Open Positions</p>
									</button>
								</Link>
								<div className='image-wapper'>
									<Image src={CubeImage} alt='..' />
								</div>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		</div>
	)
}

export default ExplorePassion
